"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoulHarvestAbilityHandler = exports.SoulHarvestActorAbilityFactory = exports.SoulHarvestAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const Random_1 = require("../../utils/Random");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class SoulHarvestAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SoulHarvest;
        this.__typeName = "SoulHarvest";
    }
}
exports.SoulHarvestAbilityArgs = SoulHarvestAbilityArgs;
let SoulHarvestActorAbilityFactory = class SoulHarvestActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SoulHarvest", "OneEnemies", 2);
    }
};
SoulHarvestActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SoulHarvest")
], SoulHarvestActorAbilityFactory);
exports.SoulHarvestActorAbilityFactory = SoulHarvestActorAbilityFactory;
let SoulHarvestAbilityHandler = class SoulHarvestAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: "SoulHarvest",
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: targetId,
            projectileType: "MultiBobbingFrostBolts",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 120),
                AbilityDamage_1.AbilityDamage.Focus("Frost", 120),
            ],
            onHit(sequence) {
                container.applyDebuffs({
                    attackerId: ability.invokerId,
                    targetId: targetId,
                    effects: [
                        {
                            duration: Duration_1.Duration.Turns(2),
                            effect: new core_1.VulnerabilityEffectArgs((0, Random_1.random)(4, 8))
                        },
                        (0, Random_1.randomPercent)() <= 25 && {
                            duration: Duration_1.Duration.Turns(1),
                            effect: new core_1.StunEffectArgs()
                        },
                    ].filter(Boolean),
                    sequence: sequence.pushSequence("sequential"),
                    onApplied(sequence, effects) {
                        if (effects.some(({ effect }) => effect.__typeName === "Stun")) {
                            sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "IceRupture"));
                        }
                    }
                });
            }
        });
    }
};
SoulHarvestAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SoulHarvest)
], SoulHarvestAbilityHandler);
exports.SoulHarvestAbilityHandler = SoulHarvestAbilityHandler;
